export default __webpack_public_path__ + "static/media/Logo.44ce7bb5.svg";